/* eslint-disable complexity */

/* eslint-disable no-magic-numbers */

/**
 * @file 宿主环境判断
 * @author dafo<huanghouin@baijiahulian.com>
 * @module util/env
 */
// 判断当前是不是在浏览器端
export var isClient = typeof window !== 'undefined';
/**
 * 客户端类型
 *
 * @enum {number}
 */

export var ClientType = {
  // PC 站
  PC: 0,
  // M 站
  M: 1,
  // iOS App 内嵌的页面
  IOS: 2,
  // Android App 内嵌的页面
  ANDROID: 3,
  // Windows 客户端内嵌的页面
  WIN: 4,
  // Mac 客户端内嵌的页面
  MAC: 5,
  // 微信公众号页面
  WX: 6,
  // 小程序页面
  MP: 7,
  // iPad 内嵌页面，需要区分 iPhone 和 iPad
  IPAD: 8
}; // 此正则可以匹配所有高途下矩阵app 高途、途途、公考、精品
// android
// gaotuapp-android/xx/gaotu
// gaotuapp-android/xx/gongkao
// gaotuapp-android/xx/jingpin
// gaotuapp-android/xx/tutu
// ios
// gaotuapp-ios/xx/gaotu
// gaotuapp-ios/xx/gongkao
// gaotuapp-ios/xx/jingpin
// gaotuapp-ios/xx/tutu

export var APP_REGEXP = /gaotuapp/;
var isInGaoTuAppTemp = false;

if (isClient) {
  isInGaoTuAppTemp = APP_REGEXP.test(navigator.userAgent);
}

export var isInGaoTuApp = isInGaoTuAppTemp;
var browser;
/**
 * 解释宿主相关信息
 *
 * @param {?string} ua use agent 字符串
 * @param {?string} platform 平台标识
 * @return {Browser}
 */

export var parse = function parse() {
  var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : navigator.userAgent;
  var platform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : navigator.platform;
  ua = String(ua).toLowerCase();
  platform = String(platform).toLowerCase(); // chrome is included in the edge UA, so need to check for edge first,
  // before checking if it's chrome.

  var UA = ua.match(/(edge)[\s/:]([\w\d.]+)/);

  if (!UA) {
    UA = ua.match(/(opera|ie|firefox|chrome|trident|crios|version)[\s/:]([\w\d.]+)?.*?(safari|(?:rv[\s/:]|version[\s/:])([\w\d.]+)|$)/) || [null, 'unknown', 0];
  }

  var name = {
    trident: 'ie',
    crios: 'chrome',
    version: UA[3]
  }[UA[1]] || UA[1];

  if (UA[1] === 'trident' && UA[4]) {
    UA[2] = UA[4];
  }

  platform = ua.match(/ip(?:ad|od|hone)/) ? /ipad/.test(ua) ? 'ipad' : 'ios' : (ua.match(/(?:webos|android)/) || ua.match(/mac|win|linux/) || [platform || 'other'])[0];

  if (platform === 'windows') {
    platform = 'win';
  }

  var browser = {
    name: name,
    platform: platform,
    env: ClientType.PC,
    version: parseFloat(UA[1] === 'opera' && UA[4] ? UA[4] : UA[2])
  };
  var PLATFORM = platform.toUpperCase();

  if (/(?:ios|ipad|android)/.test(platform)) {
    browser.env = ClientType.M;

    if (/micromessenger/.test(ua)) {
      var isMiniProgram = /miniprogram/i.test(ua) // eslint-disable-next-line no-underscore-dangle
      || window.__wxjs_environment === 'miniprogram' || window.wx && window.wx.miniProgram;
      browser.env = isMiniProgram ? ClientType.MP : ClientType.WX;
    } else if (/(?:genshuixue|gaotu|bjzkt|jinyouxuetang|android\/crm-)/.test(ua) && PLATFORM in ClientType) {
      browser.env = ClientType[PLATFORM];
    }

    return browser;
  }

  if (/wenzaizhiboclient-/.test(ua) && PLATFORM in ClientType) {
    browser.env = ClientType[PLATFORM];
  }

  return browser;
};
/**
 * @typedef Browser
 * @property {string} name 宿主名
 * @property {number} version 版本号
 * @property {string} platform 系统平台标识
 * @property {number} env 宿主标识
 */

/**
 * 获取宿主相关信息
 *
 * @param {?string} ua use agent 字符串
 * @param {?string} platform 平台标识
 * @return {Browser}
 */

export default function get(ua, platform) {
  return browser || (browser = parse(ua, platform));
} // 非线上环境判断

export var isTestReg = /^(?=test[0-9]?\b|beta[0-9]?\b|dev[0-9]?\b|localhost\b|(?:[0-9]{1,3}\.){3}[0-9]{1,3}\b)/;